import type { ReactNode } from 'react'
import React from 'react'

import * as S from './EditorPanelSubheader.styled'

type Props = {
  children: ReactNode
}

export const EditorPanelSubheader = ({ children }: Props) => {
  if (!children) {
    return null
  }

  return <S.Container>{children}</S.Container>
}
